import api from './api';

export interface RentalZoneSummary {
  _id: string;
  code: string;
  name: string;
  zoneLevel: string;
  isActive: boolean;
  packageCount: number;
  activePackageCount: number;
  hasPackages: boolean;
}

export interface RentalPackageGroupApi {
  groupKey: string;
  packageGroupCode: string;
  packageHr: number;
  packageKm: number;
  zoneCode: string;
  serviceSlug: string;
  isActive: boolean;
  rowIds: string[];
  vehiclePrices: Array<{
    vehicleTypeCode: string;
    price: number;
    graceTimeMin: number;
    extraKmPrice: number;
    rowId?: string;
    rowCode?: string;
  }>;
}

export async function listRentalZones(params?: { search?: string; page?: number; limit?: number }) {
  const res = await api.get('/admin/transport/rental/zones', { params });
  return {
    data: (res.data?.data || []) as RentalZoneSummary[],
    total: res.data?.meta?.total ?? 0,
    page: res.data?.meta?.page ?? 1,
    limit: res.data?.meta?.limit ?? 50,
  };
}

export async function listRentalPackagesByZone(
  zoneCode: string,
  params?: { serviceSlug?: string; page?: number; limit?: number },
) {
  const res = await api.get(`/admin/transport/rental/zones/${encodeURIComponent(zoneCode)}/packages`, { params });
  return res.data?.data as {
    zone: { _id: string; code: string; name: string; zoneLevel: string; isActive: boolean };
    groups: RentalPackageGroupApi[];
    total: number;
    page: number;
    limit: number;
  };
}

export async function checkRentalDuplicate(body: {
  zoneCode: string;
  packageHr: number;
  packageKm: number;
  serviceSlug: string;
  excludeGroupCode?: string;
}) {
  const res = await api.post('/admin/transport/rental/check-duplicate', body);
  return res.data?.data;
}

export async function toggleRentalPackageStatus(body: {
  zoneCode: string;
  packageGroupCode: string;
  serviceSlug: string;
  isActive: boolean;
}) {
  const res = await api.patch('/admin/transport/rental/packages/status', body);
  return res.data?.data;
}

export async function deleteRentalPackageGroup(body: {
  zoneCode: string;
  packageGroupCode: string;
  serviceSlug: string;
}) {
  const res = await api.delete('/admin/transport/rental/packages/group', { data: body });
  return res.data?.data;
}

export async function getBookingRentalPackages(params?: {
  zoneCode?: string;
  lat?: number;
  lng?: number;
  serviceSlug?: string;
  serviceId?: string;
}) {
  const res = await api.get('/transport/rental/packages', { params });
  return res.data?.data;
}
